// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styles-module__loadingShimmerContainer___nHzST {\n  display: flex;\n  flex-direction: column;\n  width: 70%;\n  row-gap: 1rem;\n}\n.styles-module__withMargin___Xg-i- {\n  margin: 2rem 0;\n}\n", "",{"version":3,"sources":["webpack://common/components/loading/with-loading-shimmer/styles.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,UAAA;EACA,aAAA;AACF;AAEA;EACE,cAAA;AAAF","sourcesContent":[".loadingShimmerContainer {\n  display: flex;\n  flex-direction: column;\n  width: 70%;\n  row-gap: 1rem;\n}\n\n.withMargin {\n  margin: 2rem 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingShimmerContainer": "styles-module__loadingShimmerContainer___nHzST",
	"withMargin": "styles-module__withMargin___Xg-i-"
};
export default ___CSS_LOADER_EXPORT___;
